<div class="lum-advance-select__wrapper">
  <div
    #toggleButton
    [ngClass]="classes"
    class="lum-advance-select__selector text-ellipsis"
    (click)="toggleSelect()"
  >
    {{ selectedOption?.label ?? placeholder }}
  </div>

  <ul #menu [ngClass]="{ open: isToggled }" class="lum-advance-select__items">
    <ng-container *ngIf="!loading; else loader">
      <li (click)="itemSelect(null)">
        <div class="lum-advance-select__list-item-content">-- None --</div>
      </li>
      <li
        *ngFor="let item of items"
        class="lum-advance-select__list-item"
        (click)="itemSelect(item)"
      >
        <div class="lum-advance-select__list-item-content">
          {{ item.label }}
          <div class="lum-advance-select__list-item-content-subtext">
            {{ item.subLabel }}
          </div>
        </div>
      </li>
    </ng-container>

    <ng-template #loader>
      <li class="lum-advance-select__list-item">Loading...</li>
    </ng-template>
  </ul>
</div>
